module.exports = __webpack_public_path__ + "static/media/Page02_jerry.956539ae.jpg";